import type { AffiliateType } from "@/types";

export interface DocumentoForm {
  tipo: string;
  archivoUrl: string;
  archivoNombre: string;
}

export interface VehiculoForm {
  id: string;
  tipo: string;
  tipoPersonalizado: string;
  marca: string;
  modelo: string;
  anio: string;
  color: string;
  placa: string;
  capacidad: string;
  tipoCarga: string;
  caracteristicas: string;
  zonaOperacion: string;
  disponibilidad: string;
  diasDisponibles: string;
  horario: string;
  distanciaMaxima: string;
  fotoUrl: string;
  documentos: DocumentoForm[];
}

export interface AfiliacionForm {
  tipo: "" | AffiliateType;
  nombreCompleto: string;
  cedula: string;
  telefono: string;
  whatsapp: string;
  email: string;
  ciudad: string;
  provincia: string;
  direccionZona: string;
  rolVehiculo: string;
  empresaNombreComercial: string;
  empresaRazonSocial: string;
  rnc: string;
  contactoNombre: string;
  contactoCargo: string;
  sitioWeb: string;
  redes: string;
  servicios: string[];
  dispDias: string;
  dispHorario: string;
  dispZona: string;
  dispDistancia: string;
  vehiculos: VehiculoForm[];
  documentosGenerales: DocumentoForm[];
}

export const emptyVehiculo = (): VehiculoForm => ({
  id: `veh-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`,
  tipo: "",
  tipoPersonalizado: "",
  marca: "",
  modelo: "",
  anio: "",
  color: "",
  placa: "",
  capacidad: "",
  tipoCarga: "",
  caracteristicas: "",
  zonaOperacion: "",
  disponibilidad: "disponible",
  diasDisponibles: "",
  horario: "",
  distanciaMaxima: "",
  fotoUrl: "",
  documentos: [],
});

export const initialAfiliacionForm: AfiliacionForm = {
  tipo: "",
  nombreCompleto: "",
  cedula: "",
  telefono: "",
  whatsapp: "",
  email: "",
  ciudad: "",
  provincia: "",
  direccionZona: "",
  rolVehiculo: "",
  empresaNombreComercial: "",
  empresaRazonSocial: "",
  rnc: "",
  contactoNombre: "",
  contactoCargo: "",
  sitioWeb: "",
  redes: "",
  servicios: [],
  dispDias: "",
  dispHorario: "",
  dispZona: "",
  dispDistancia: "",
  vehiculos: [emptyVehiculo()],
  documentosGenerales: [],
};

export const WIZARD_STEPS = [
  { id: "tipo", label: "Tipo de afiliado", short: "Tipo" },
  { id: "datos", label: "Información", short: "Información" },
  { id: "vehiculos", label: "Vehículos", short: "Vehículos" },
  { id: "servicios", label: "Servicios y disponibilidad", short: "Servicios" },
  { id: "documentos", label: "Documentación", short: "Documentos" },
  { id: "revision", label: "Revisión", short: "Revisión" },
  { id: "enviar", label: "Enviar solicitud", short: "Enviar" },
];